/** @jsxImportSource @emotion/react */
import React from 'react'
import css from '@emotion/css/macro'
import { getImageThumbnailId } from '@sportninja/common/reducers/helpers'

interface GameListTeamLogoProps {
  team: any
  className?: string
  style?: React.CSSProperties
}

const GameListTeamLogo: React.FC<GameListTeamLogoProps> = ({
  team,
  className,
  style,
}) => {
  const imageSrc =
    getImageThumbnailId(team) ||
    '/images/generic_placeholders/placeholder_team.png'

  return (
    <div
      className={className}
      css={css`
        display: flex;
        padding: 2px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        border-radius: 16px;
        border: 1px solid var(--Neutrals-neutrals-30, #ebebec);
        background: var(--Neutrals-neutrals-0, #fff);
        width: 64px;
        height: 64px;
        overflow: hidden;
      `}
      style={style}
    >
      <img
        src={imageSrc}
        alt={team?.name_full || 'Team Logo'}
        css={css`
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 14px; /* Slightly less than container to fit inside padding/border */
        `}
      />
    </div>
  )
}

export default GameListTeamLogo
